import { useEnvConfigStore } from "@/store/env.store";
import {  formatTime, getSupportSiteUrl, IsNullorWhiteSpace, removeStyles } from "@/utilities/utilities";
import axios from "axios";
import { storeToRefs } from "pinia";
import { computed, defineComponent, onActivated, onBeforeMount, onMounted, reactive, ref } from "vue";
import bnacpa from '@/assets/images/bnacpa.jpg'
import { useGlobalStore } from "@/store/globalStore";
import { GetAllConversation, GetAnswerByArtCatId, GetFaqs } from "@/constants/url-constants";
import { SpanSupportApiServices } from "@/assets/services/spanSupport/apiServices";
import { useChatMessageInfo } from "@/store/chatInfo.store";
import tax990ChatWithUS from "../../assets/images/tax990chatwithus.svg"

export default defineComponent({
  name:"Home",
  setup(props,ctx) {

    const feeds = ref()
    const envConfigStore = useEnvConfigStore()
    const {aiChatBotKeys,envInfo} = storeToRefs(envConfigStore)
    let {UserDetails,HelpArticleId,IsFocusSearch,BotIconPath,ActiveComponent,GetHelpQuestionAnswers,GetAnswerBasedOnQuestions,CacheChatConversationHistory} = useGlobalStore()
    const isPageLoader =  ref<boolean>(true)
    const isFeedAvailable = ref<boolean>(true)
    const isWealthRabbit = ref<boolean | undefined>(false)
    const helpQuestionsAns = ref<{}[]>([])
    const spanSupportApiServices = reactive(new SpanSupportApiServices())
    const chatConversationHistory = ref<Record<string,string>>({})
    const pageDetailArticles = ref<Record<string,string>>({})
    const videoReference = ref<Record<string,string>>({})
    const {ChatOldSessionId} = storeToRefs(useChatMessageInfo())
    const retryAttempt = ref<number>(0)
    const isGetConversationDetailProcessing = ref<boolean>(false)

    onActivated(()=>{
      if(aiChatBotKeys.value?.IsHistory && !IsNullorWhiteSpace(UserDetails.value?.EmailAddress) && !isGetConversationDetailProcessing.value)
        {
          getConversationByEmail()
        }
    })

    onBeforeMount(()=>{
      getHelpQuestionAnswers()
      if(aiChatBotKeys.value?.IsHistory && !IsNullorWhiteSpace(UserDetails.value?.EmailAddress))
      {
        getConversationByEmail()
      }
    })

    onMounted(()=>{
      // isWealthRabbit.value = aiChatBotKeys.value?.ProductName.toLocaleLowerCase().includes("wealthrabbit")
      // isWealthRabbit.value ? wealthrabbitFeeds() : ""
      // getLatestUpdates()
  })
  

    function getLatestUpdates(){
      const feedUrl = aiChatBotKeys.value?.HomeFeedUrl;
      axios.get('https://api.rss2json.com/v1/api.json',{
        params:{
          rss_url: feedUrl
        }
      })
      .then((res)=>res.data)
      .then((res)=>{
       if(!IsNullorWhiteSpace(res.items))
       {
      
        feeds.value = res.items
        feeds.value = feeds.value.slice(0, 2);
        isPageLoader.value = false
       }
       else
       {
        isFeedAvailable.value = false
       }
      })
      .catch((e)=>{
        isFeedAvailable.value = false
      })
    }



    function redirectToSupportSite(data:object){
    window.open(data.link,'_blank')
    }

    function navigateToOther(widget:string='Help'){
      ctx.emit("NavigateToOther",widget)
    }

    function wealthrabbitFeeds(){

      let feedItems = [
        {
          title:"What is a SIMPLE IRA",
          author:"",
          pubDate:"",
          description:"SIMPLE IRA is a type of Tax-deferred retirement saving plan that most small businesses with 100 or fewer employees can use.",
          image:"https://www.wealthrabbit.com/images/simple-ira-image.svg",
          link:"https://www.wealthrabbit.com/resources/what-is-simple-ira"
        },
        {
          title:"SIMPLE IRA, 401(k), and SEP IRA",
          author:"",
          pubDate:"",
          description:"Employers must either match employee contributions up to 3% of their salary or contribute 2% of each eligible employee's salary.",
          image:"https://www.wealthrabbit.com/images/simple-ira-401k-sep.svg",
          link:"https://www.wealthrabbit.com/resources/401(k)-vs-sep-vs-simple-ira"
        },
        {
          title:"SIMPLE IRA Matching Rules",
          author:"",
          pubDate:"",
          description:"A SIMPLE IRA and SEP IRA is a retirement plan for small businesses, while a 401(k) is designed for larger companies. ",
          image:"https://www.wealthrabbit.com/images/matching-rules.svg",
          link:"https://www.wealthrabbit.com/resources/simple-ira-matching-rules"
        }
      ]
      feeds.value = feedItems
      isPageLoader.value = false
    }

    async function getHelpQuestionAnswers() {
     const getHelpQuestionAnswersRequest = {
      ProductId: UserDetails.value?.ProductId,
      PageId: UserDetails.value?.PageId
     }
    await GetHelpQuestionAnswers(getHelpQuestionAnswersRequest)
        .then((res) => {
          isPageLoader.value = false
          if(!IsNullorWhiteSpace(res))
          {
            helpQuestionsAns.value = res?.FAQs?.slice(1,5)
            // res?.PageHelps.forEach(async(item:Record<string, string>)=>{
            //   item.description = await getAnswerBasedOnQuestions(item)
            // })
            // pageDetailArticles.value = res?.PageHelps?.slice(0,1)
            

            pageDetailArticles.value = res?.FAQs?.slice(0,1)

             res?.VideoURLs.forEach((item:Object)=>{
              let youtubeDetails = getYouTubeThumbnail(item?.VideoUrl)
              item.VideoUrl = youtubeDetails?.youtubeLink,
              item.thumbnail = youtubeDetails?.thumbnail
            })
            videoReference.value = res?.VideoURLs?.slice(0,1)
            getAnswerBasedOnQuestions(pageDetailArticles.value[0])
          }
          
        })
        .catch((e) => {
          isPageLoader.value = false
          if(retryAttempt.value <2 && envInfo.value?.Common_Product_Id && envInfo.value?.Common_Page_Id){
          UserDetails.value.ProductId = envInfo.value?.Common_Product_Id
          UserDetails.value.PageId =envInfo.value?.Common_Page_Id
          getHelpQuestionAnswers()
          retryAttempt.value = retryAttempt.value + 1
          }
        });
    }

   async function getAnswerBasedOnQuestions(data: Record<string, string>) {
      const getAnswerBasedOnQuestionsRequest = {
        ProductId:UserDetails.value?.ProductId,
        ArticleCategoryId: data?.ArticleCategoryId,
      }
     await GetAnswerBasedOnQuestions(getAnswerBasedOnQuestionsRequest)
        .then((res) => {
          const response = res
          if(!IsNullorWhiteSpace(response)){
           const ans =response?.Answer?.replaceAll(/font-family:\s*Poppins,\s*sans-serif;?|color:\s*#475666;?/g, '');
          const parser = new DOMParser();
          const doc = parser.parseFromString(ans, "text/html");

          // Add target="_blank" to all <a> tags
          doc.querySelectorAll("a").forEach((link) => {
            link.setAttribute("target", "_blank");
          });
          pageDetailArticles.value[0].Answer = doc.body.innerHTML;
        }
        })
        .catch((e) => {
          pageDetailArticles.value[0].Answer = `TaxBandits is an IRS-authorized e-file provider that helps busineses, employers, CPAs, accountants, and various other tax professionals to efficiently manage tax compliance.`
        });
    }

    function openArticleAnswer(collection:Record<string,string>){
      HelpArticleId.value = collection.ArticleCategoryId
      navigateToOther()
    }

    function viewAllArticle(){
      // HelpArticleId.value = ""
      // navigateToOther()
      const url =  getSupportSiteUrl(true) + '?ref=aibot'
      window.open(url,"_blank")
    }

    function getConversationByEmail() {
      const getAllConversationRequest = {
        EmailAddress:UserDetails.value?.EmailAddress,
        IsGetLastRecord:true
      }
      isGetConversationDetailProcessing.value = true
      spanSupportApiServices
        .postMethod(GetAllConversation,getAllConversationRequest)
        .then((res) => {
          isGetConversationDetailProcessing.value = false
          CacheChatConversationHistory.value = res.ConersationDetails
          chatConversationHistory.value = res?.ConersationDetails[0]
        })
        .catch((e) => {});
    }

    const greeting = computed(()=>{
    let greetingName:string | undefined = ""
    let greetingDescription:string | undefined = ""
    greetingName = aiChatBotKeys.value?.BotWelcomeMessage ||  'Hello' +( IsNullorWhiteSpace(UserDetails.value?.ContactName) || (UserDetails.value?.ContactName?.length??0) > 9 ? '' : ` ${UserDetails.value?.ContactName?.split(" ")[0]}`)
    greetingDescription = aiChatBotKeys.value?.BotWelcomeDescription || 'How can we help?'

    return{
      greetingName,
      greetingDescription
    }
    })

    function  getYouTubeThumbnail(link:string) {
      let thumbnail = ""
      let youtubeLink = ""
      const videoId = link.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/)?.[1] ||
                      link.match(/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^&]+)/)?.[1];
        thumbnail = `https://img.youtube.com/vi/${videoId?.trim()}/0.jpg` 
        youtubeLink = `https://www.youtube.com/embed/${videoId?.trim()}` 
        return{
          thumbnail,
          youtubeLink
        }
    }
    
    function navigateAndShowExistingChat(thread:Record<string,string>){
      ChatOldSessionId.value = thread.SessionId
      ctx.emit("GetChatHistory","OldChatFromHome")
    }

    function redirectToHomeSite(){
      const url = envInfo.value?.Support_Site + '?ref=aibot'
       window.open(url,"_blank")
    }

    return {
      feeds,
      formatTime,
      redirectToSupportSite,
      navigateToOther,
      UserDetails,
      IsNullorWhiteSpace,
      aiChatBotKeys,
      bnacpa,
      isPageLoader,
      isFeedAvailable,
      isWealthRabbit,
      helpQuestionsAns,
      openArticleAnswer,
      viewAllArticle,
      chatConversationHistory,
      IsFocusSearch,
      HelpArticleId,
      greeting,
      pageDetailArticles,
      videoReference,
      BotIconPath,
      navigateAndShowExistingChat,
      envInfo,
      ActiveComponent,
      redirectToHomeSite,
      isGetConversationDetailProcessing,
      getSupportSiteUrl,
      tax990ChatWithUS
    };
  },
});
